import React from 'react';
import { MdClose } from "react-icons/md"
import { Button, Modal } from 'react-bootstrap';

function AddPayCodeModal(props) {
    const { setModalShow } = props;
    const projectOptions = [
        {
            name: "Paycode 1",
        },
        {
            name: "Paycode 2",
        },
    ];
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className="d-flex justify-content-between mb-5">
                    <h2>Pay Code</h2>
                    <MdClose onClick={() => setModalShow(false)} className="align-self-center cursor-pointer" size={30} />
                </div>
                <hr />
                <div className="row mt-7 mb-5">
                    <div className="col-12 mb-sm-3">
                        <div className="select_disable mr-2 mb-2">
                            <label className="form-label add-form-label" htmlFor="catalog">
                                Pay Code Type
                            </label>
                            <select
                                name="designationOptions"
                                className="add-form-select"
                            >
                                <option value="" selected disabled>
                                    Select Option
                                </option>

                                {projectOptions?.map((list, index) => {
                                    return (
                                        <option
                                            key={index}
                                            value={list.name}
                                            selected={
                                                list.name === "" ? true : false
                                            }
                                        >
                                            {list.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="col-12 mb-sm-3">
                        <div className="select_disable mr-2 mb-2">
                            <label className="form-label add-form-label" htmlFor="catalog">
                                Pay code
                            </label>
                            <input type="text" className='add-form-input-class form-control' placeholder='Enter Pay Code' />
                        </div>
                    </div>
                    <div className="col-12 mt-5">
                        <button
                            type="button"
                            className="generic-gradient-button w-100"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddPayCodeModal